export { default as FolderAltSolidIcon } from './FolderAltSolidIcon';
